import { useEffect, useRef } from 'react'

import { Field, Form, Formik } from 'formik'

interface StageNotesProps {
  editingNotes: boolean
  activeGroupNotes: string | null
  setEditingNotes: (editing: boolean) => void
  updateStageNotes: (notes: string) => void
}

export const StageNotes = ({
  editingNotes,
  activeGroupNotes,
  setEditingNotes,
  updateStageNotes,
}: StageNotesProps) => {
  const focusRef = useRef<HTMLTextAreaElement>(null)

  // Set focus to "notes" input box when editing starts
  useEffect(() => {
    if (editingNotes && focusRef.current) {
      focusRef.current.focus()
    }
  }, [editingNotes])

  if (!editingNotes && !activeGroupNotes) {
    return null
  }

  if (editingNotes) {
    return (
      <div className='p-2'>
        <Formik
          initialValues={{ notes: activeGroupNotes || '' }}
          onSubmit={() => {
            /* Do Nothing */
          }}
        >
          {({ values }) => (
            <Form
              onBlur={() => updateStageNotes(values.notes)}
              onKeyDown={(event) => {
                if (event.ctrlKey && event.key === 'Enter') {
                  updateStageNotes(values.notes)
                }
              }}
            >
              <Field
                innerRef={focusRef}
                id='notes'
                name='notes'
                as='textarea'
                placeholder='Stage notes'
                className='border p-2 w-full border-gray-200 focus:border-sky-300 text-sm'
              />
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  return (
    <div
      className='p-2 pr-4 my-1 cursor-pointer text-sm whitespace-pre-wrap'
      onClick={() => setEditingNotes(true)}
    >
      <p className='font-bold mb-1'>Stage Notes</p>
      <p className='italic'>{activeGroupNotes}</p>
    </div>
  )
}
